import { apiGet } from 'common/apiRequests';
import { STRINGS } from 'config';

export const getTreatmentCategories = () => (dispatch, getState) => {
  const { practiceId } = getState().consultationReducer.practice;
  dispatch({ type: STRINGS.TREATMENT_CATEGORIES_REDUCER.GET_TREATMENT_CATEGORIES_REQUEST });
  apiGet('/', practiceId)
    .then(response => {
      if (!response.body) {
        return dispatch({
          type: STRINGS.TREATMENT_CATEGORIES_REDUCER.GET_TREATMENT_CATEGORIES_ERROR,
          payload: 'GET_TREATMENT_CATEGORIES_ERROR: No response body',
        });
      }
      return dispatch({ type: STRINGS.TREATMENT_CATEGORIES_REDUCER.GET_TREATMENT_CATEGORIES_SUCCESS, payload: response.body });
    })
    .catch(error => dispatch({ type: STRINGS.TREATMENT_CATEGORIES_REDUCER.GET_TREATMENT_CATEGORIES_ERROR, payload: error }));
};
